<div id="proposedsolution_container">
  <span class="zsd-cust-common-pageheading-font">                        
      {{ 'ProposedSolution.newrequestdetail' | translate }}
    </span>
  <div class="row mt-2">
        <div class="col-md-6 col-xl-4 col-lg-4 col-11 col-sm-11 card" id="newrequestcard">
            <div class="card-body">
                <div id="newrequest_breadcrumbs" class="breadcrumb-font">
                    <span style="color: #0079EF; cursor: pointer;" [routerLink]='["/newrequest"]'>New Request</span> 
                    <em class="fa fa-angle-right fa-lg px-1"></em>
                    <span> New Request Detail </span>
                </div>
                <div id="success_message">
                    <div class="row">
                        <div class="col-md-3 col-xl-3 col-lg-3 col-12 col-sm-12" id="requestid"> {{requestId}} </div>
                        <div class="col-md-9 col-xl-9 col-lg-9 col-12 col-sm-12">  
                            {{ 'ProposedSolution.successmessage' | translate }}                  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <span class="zsd-cust-common-pageheading-font mt-2">
            {{ 'ProposedSolution.proposedsolution' | translate }}
            </span>
        <div class="row mt-2">      
            <div class="col-lg-9 col-xl-10 col-md-12 col-xs-12 col-sm-12 col-12">
                    <zsd-proposedsolutionlist></zsd-proposedsolutionlist>  
            </div>
        </div>
</div>

